import React, { useEffect, useRef, useState } from 'react';

import { SimpleImage } from '$partials/media';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

const AmbassadorCard = ({
    media,
    name,
    role,
    descriptionLineOne,
    descriptionLineTwo
}) => {
    return (
        <div className='flex flex-col w-full'>
            <figure className='rounded-listing-item overflow-hidden pointer-events-none select-none aspect-video'>
                <SimpleImage
                    {...media.image}
                    className='h-full w-full object-cover object-center' />
            </figure>
            <div className='pt-12 pb-8 border-b border-border-default'>
                <p className='type-style-sans-body-med'>
                    {name}
                </p>
                <p className='type-style-sans-body'>
                    {role}
                </p>
            </div>
            <div className='pt-12'>
                <p className='type-style-sans-body'>
                    {descriptionLineOne}
                </p>
                <p className='type-style-sans-h3-med mt-2'>
                    {descriptionLineTwo}
                </p>
            </div>
        </div>
    );
};

/**
 * @type {import('$types/components/partials/modules.d.ts').AmbassadorCarouselBlock}
 */

const AmbassadorCarousel = ({
    ambassadors,
    backgroundColor,
    title,
    text,
}) => {
    const bgColor = `bg-surface-panel-${backgroundColor}`;
    const containerRef = useRef(null);
    const [ imageItems, setImageItems ] = useState(ambassadors);
    const [ duration, setDuration ] = useState(50);
    // hooks
    useEffect(() => {
        const handleResize = () => {

            // Duplicate messages to fill screen
            let displayedLogo = imageItems;
            while (displayedLogo.length < 5) {
                displayedLogo = displayedLogo.concat(imageItems);
            }

            // // Duplicate messages to handle overflow repeats
            const duplicateCount = 5;
            let duplicatedLogos = [];
            for (let i = 0; i < duplicateCount; i++) {
                duplicatedLogos = duplicatedLogos.concat(displayedLogo);
            }

            const totalWidth = displayedLogo.reduce((partialSum, a) => partialSum + 274, 0);
            setDuration((totalWidth / 1440 * 100) * 1.5);
            setImageItems(duplicatedLogos);
        };

        handleResize();
        window.addEventListener('resize', handleResize, { passive: true });
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <section
            className={`${bgColor} col-padding rounded-lg pt-24 pb-16`}
            ref={containerRef}>
            <h2 className='type-style-sans-h1 w-full sm:w-7/12 lg:w-5/12'>
                {title}
            </h2>
            {text && (
                <p className='type-style-sans-h3 mt-8 sm:pr-40 md:pr-48 w-full sm:w-7/12 lg:w-5/12'>
                    {text}
                </p>
            )}
            <div
                className='col-wrapper-breakout mt-24 overflow-hidden'>
                <div className='ticker relative w-full flex'>
                    {/* Output ticker twice to fake marquee effect */}
                    {[0, 1].map((_block, bdx) => {
                        return (
                            <ul
                                className='ticker__items w-fit h-full flex flex-shrink-0 flex-grow-0'
                                key={bdx}
                                style={{animationDuration: `${duration}s`}}>
                                {imageItems.map((item, idx) => {
                                    return (
                                        <li
                                            className='w-[274px] px-8 ticker__item flex flex-shrink-0 flex-grow-0 items-center justify-center whitespace-nowrap'
                                            key={item.id}>
                                            <AmbassadorCard
                                                descriptionLineOne={item.descriptionLineOne}
                                                descriptionLineTwo={item.descriptionLineTwo}
                                                media={item.media}
                                                name={item.name}
                                                role={item.role} />
                                        </li>
                                    );
                                })}
                            </ul>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default AmbassadorCarousel;
